import { FetchAPI } from '../Main/fetchAPI';
import { GetBillingProperties, GetTotalBillingProperties } from './billingProperties';
import { BILLING, CLIENT } from '../constants';

const BILLING_SESSIONS = `${BILLING}/sessions`;
const BILLING_NB_SESSIONS = `${BILLING}/non-billable/sessions`;
const BILLING_NC_SESSIONS = `${BILLING}/non-credentialed/sessions`;
const BILLING_LIMITED_PERMIT_SESSIONS = `${BILLING}/limited-permit/sessions`;
const BILLING_BACKDATED_SESSIONS = `${BILLING}/backdated/sessions`;

export const Billing = {
	getSessions: (data: GetBillingProperties) => {
		const {
			page,
			pageSize,
			direction,
			orderBy,
			searchString,
			startDate,
			endDate,
			onlyNew,
			userId,
			clientIds,
			mbhBillingStatus,
		} = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);
		if (mbhBillingStatus) query.set('mbhBillingStatus', mbhBillingStatus);

		return FetchAPI.getJson({
			urlStr: `${BILLING_SESSIONS}/?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	getNonBillableSessions: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.getJson({
			urlStr: `${BILLING_NB_SESSIONS}/?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	getNonCredentialedSessions: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('startDate', startDate);
		query.set('userId', userId);
		query.set('searchString', searchString);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.getJson({
			urlStr: `${BILLING_NC_SESSIONS}/?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadNonBillableExcelReport: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.postJson({
			urlStr: `${BILLING_NB_SESSIONS}/xlsx?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadMBHExcelReport: (data: GetBillingProperties) => {
		const {
			page,
			pageSize,
			direction,
			orderBy,
			searchString,
			startDate,
			endDate,
			onlyNew,
			userId,
			clientIds,
			includeAdditionalData = false,
		} = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);
		query.set('includeAdditionalData', `${includeAdditionalData}`);

		return FetchAPI.postJson({
			urlStr: `${BILLING_SESSIONS}/xlsx/v2?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadNCExcelReport: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.postJson({
			urlStr: `${BILLING_NC_SESSIONS}/xlsx?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadTotalSesions: (data: GetTotalBillingProperties) => {
		const { startDate, endDate, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		if (userId) query.set('userId', userId);

		return FetchAPI.getJson({
			urlStr: `${BILLING_NC_SESSIONS}/total/xlsx?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	getLimitedPermitSessions: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('startDate', startDate);
		query.set('userId', userId);
		query.set('searchString', searchString);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.getJson({
			urlStr: `${BILLING_LIMITED_PERMIT_SESSIONS}?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadLimitedPermitSessions: (data: GetBillingProperties) => {
		const { page, pageSize, direction, orderBy, searchString, startDate, endDate, onlyNew, userId, clientIds } = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		query.set('startDate', startDate);
		query.set('userId', userId);
		query.set('searchString', searchString);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.postJson({
			urlStr: `${BILLING_LIMITED_PERMIT_SESSIONS}/xlsx?${query.toString()}${
				clientIds.length ? `&clientIds=${ids}` : ''
			}`,
		});
	},
	getBackdatedSessions: (data: GetBillingProperties) => {
		const {
			page,
			pageSize,
			direction,
			orderBy,
			searchString,
			startDate,
			endDate,
			onlyNew,
			userId,
			clientIds,
			createdById,
			onlySubmitted,
			credentialed,
		} = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (createdById) query.set('createdById', createdById);
		if (typeof credentialed === 'boolean') query.set('credentialed', `${credentialed}`);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);
		query.set('onlySubmitted', `${onlySubmitted}`);

		return FetchAPI.getJson({
			urlStr: `${BILLING_BACKDATED_SESSIONS}/?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	downloadBackdatedSessions: (data: GetBillingProperties) => {
		const {
			page,
			pageSize,
			direction,
			orderBy,
			searchString,
			startDate,
			endDate,
			onlyNew,
			userId,
			clientIds,
			createdById,
			credentialed,
		} = data;
		const query = new URLSearchParams();
		let ids = '';

		if (clientIds.length) {
			ids = clientIds.join('&clientIds=');
		}
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (createdById) query.set('createdById', createdById);
		if (typeof credentialed === 'boolean') query.set('credentialed', `${credentialed}`);
		query.set('searchString', searchString);
		query.set('userId', userId);
		query.set('startDate', startDate);
		query.set('endDate', endDate);
		query.set('page', page);
		query.set('pageSize', pageSize);
		query.set('onlyNew', `${onlyNew}`);

		return FetchAPI.postJson({
			urlStr: `${BILLING_BACKDATED_SESSIONS}/xlsx?${query.toString()}${clientIds.length ? `&clientIds=${ids}` : ''}`,
		});
	},
	MBHLogs: {
		getMBHLogs: () =>
			FetchAPI.getJson({
				urlStr: `${CLIENT}/mbhlogs/latest`,
			}),
	},
};
